import { Navigate, Outlet } from 'react-router-dom';
import Loading from '@/components/business/Loading/Loading';
import { useCompany } from '@/providers/CompanyProvider/CompanyProvider';

export const RepairerOnlyRoute = () => {
    const { state } = useCompany();
    const company = state.company;
    const loaded = company && Object.keys(company).length > 0;

    if (!loaded) {
        return <Loading loading timeoutMessage="Could not load company." />;
    }
    if (company.marketplace_side !== 'Repairer') {
        return <Navigate to="/jobs" replace />;
    }
    return <Outlet />;
};
